import React from 'react'
import styled from 'styled-components'
import { padding, paddingSizes } from '@jarvis.oddle/core/theme/default'
import AddressTypeOption from './AddressTypeOption'
import { Grid, Row, Column } from '@jarvis.oddle/core/components/Grid'
import breakpoint from 'src/utils/styledComponentsBreakpoint'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

const StyledOption = styled(Column)`
  ${breakpoint('tablet')`
    ${props => (props.index % 2 === 0) ? `padding-right: ${padding[paddingSizes.small]}` : `padding-left: ${padding[paddingSizes.small]}`};
  `}
`

const AddressTypeSelector = ({
  addressTwoFormat,
  selectedAddressType,
  onSelectAddressType
}: {
  addressTwoFormat: Oms.V4.AddressTwoFormat[]
  selectedAddressType: string
  onSelectAddressType: (addressType) => void
}): JSX.Element => {
  const { t } = React.useContext(TranslationContext)
  const getAddressTypeName = (addressType) => {
    switch (addressType) {
      case 'building':
        return t('Building')
      case 'house':
        return t('House')
      default:
        return ''
    }
  }

  return <Grid>
    <Row>
      {
        addressTwoFormat.map((item, index) => <StyledOption key={item.type} index={index}>
          <AddressTypeOption
            addressType={item.type}
            selected={selectedAddressType === item.type}
            onClick={onSelectAddressType}
            addressTypeName={getAddressTypeName(item.type)}
          />
        </StyledOption>)
      }
    </Row>
  </Grid>
}

export default AddressTypeSelector
